import React, { useState } from "react";
import hasSVG from "./hasSVG";

const svgFilePath = '/images/providers/';
const pngFilePath = '/images/reviews/';

const ProviderImageInternal = (({
  provider,
  customProviders,
  alt,
  ...props
}) => {

  const [providerImage, setProviderImage] = useState((() => {
    if (customProviders !== undefined &&
      customProviders[provider] !== undefined &&
      customProviders[provider]["imageUrl"] !== undefined) {
      return customProviders[provider]["imageUrl"]
    }

    // To make assets work in storybook
    const assetUrl = !window.assetUrl.includes("localhost:") ? window.assetUrl : "https://assets.chatmeter.com/dev"

    if (provider.toLowerCase() in hasSVG) {
      return assetUrl + svgFilePath + provider.toLowerCase() + '.svg'
    } else {
      return assetUrl + pngFilePath + provider.toLowerCase() + '.png'
    }
  })());
  const [fallbackFailed, setFallbackFailed] = useState(false);
  return (
    <span className={`cm-provider-image`} {...props}>
      {
        fallbackFailed ?
          undefined :
          <img
            src={providerImage}
            alt={alt || ''}
            onError={e => {
              if (providerImage.indexOf('.png') === -1) {
                setProviderImage(i => (pngFilePath + provider.toLowerCase() + '.png'))
              } else {
                setFallbackFailed(true)
              }
            }
            }/>
      }
    </span>
  )
})

export default ({provider, ...props}) => (
  <ProviderImageInternal provider={provider} key={provider} {...props}/>) // reset the component if the provider changes
